import styled from 'styled-components';
import {Icon} from 'shared/helpers';
import {mobileLandscapeAndPortraitDevices} from 'shared/Breakpoints';

const FloatingMenuButton = styled.button`
    background-color: #1e1e1e;
    width: 30px;
    height: 36px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    transition:
        background-color 0.2s ease-in-out,
        transform 0.1s;

    &:hover {
        background-color: #333;
    }

    &:active {
        background-color: #444;
        transform: scale(0.95);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        transform: none;
        pointer-events: none;
    }

    svg {
        width: 18px;
        height: 18px;
        color: #f1f1f1;
    }

    > label {
        display: none;
    }

    ${mobileLandscapeAndPortraitDevices`
        background: white;

        &:hover {
            background-color: white;
        }

        &:active {
            background-color: white;
            transform: scale(1);
        }  
    `}
`;

export const FloatingMenuButtonIcon = styled(Icon)`
    max-width: 18px;

    &.is-spinning {
        animation: rp-copy-spin 0.8s linear infinite;
    }

    @keyframes rp-copy-spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

export default FloatingMenuButton;
